import { render, staticRenderFns } from "./EstablishmentPlatforms.vue?vue&type=template&id=58448a88&scoped=true&lang=pug&"
import script from "./EstablishmentPlatforms.vue?vue&type=script&lang=coffee&"
export * from "./EstablishmentPlatforms.vue?vue&type=script&lang=coffee&"
import style0 from "./EstablishmentPlatforms.vue?vue&type=style&index=0&id=58448a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58448a88",
  null
  
)

component.options.__file = "EstablishmentPlatforms.vue"
export default component.exports